// extracted by mini-css-extract-plugin
module.exports = {"whiteStyle":"e_xsb","prefix":"e_ysb","counter":"e_zsb"};